// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_UnidadesPagantesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de GET /migration/assinaturas/unidades-pagantes.
 *
 * `truncado` NAO e detalhe: a varredura da origem para em 300 linhas. Se ela
 * bateu no teto, a lista abaixo nao e a rede inteira — e apresentar numero
 * truncado como total e como se produz conclusao errada a partir de dado
 * aparentemente medido.
 */
import type { Migration_UnidadePaganteRow } from './Migration_UnidadePaganteRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Migration_UnidadesPagantesResponseDados {
registros: Migration_UnidadePaganteRow[]
truncado: boolean
}

export type Migration_UnidadesPagantesResponse = ApiResponse<Migration_UnidadesPagantesResponseDados>;

registerResponseContract('Migration_UnidadesPagantesResponse', {
  registros: {
    type: 'array',
    required: true,
    items: {
      zoho_id:         { type: 'string',  required: false },
      zoho_id_unidade: { type: 'string',  required: false },
      nome_unidade:    { type: 'string',  required: false },
      plano:           { type: 'string',  required: false },
      valor:           { type: 'number',  required: false },
      status:          { type: 'string',  required: false },
      gateway:         { type: 'string',  required: false },
      n_transacoes:    { type: 'number',  required: false },
      n_hooks:         { type: 'number',  required: false },
    },
  },
  truncado:  { type: 'boolean', required: true },
})
